export default "__VITE_ASSET__BNIYSoF7__"